export function isEmpty(str: string): boolean {
  return str === '' || str === undefined || str == null || str === 'null';
}
